module.exports = __webpack_public_path__ + "static/media/emergency.a470ed2b.png";